import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Wrapper } from './styles'

type Props = {
  text?: string
  style?: React.CSSProperties
  onClick?: () => void
}

const RectangleAddNew: React.FC<Props> = ({ text, style, onClick }) => {
  return (
    <Wrapper onClick={onClick} style={style}>
      <svg height="30" width="100%">
        <rect
          width="100%"
          height="100%"
          style={{ fill: '#FFFFFF', fillOpacity: 0, strokeWidth: 1, stroke: '#D4D8DD' }}
          strokeDasharray="3 3"
        />
      </svg>
      <div className="content">
        <FontAwesomeIcon icon={faPlusSquare} />
        <div className="text">{text}</div>
      </div>
    </Wrapper>
  )
}

export default RectangleAddNew
